import styled from 'styled-components';
import theme from '@cld/theme-helper';
import { typographyMixin } from '@cld/typography';

const t = theme({ basePath: 'components.tooltip.paper' });

export const Paper = styled.div`
  background: ${t`background`};
  ${(props) => typographyMixin({ ...props, size: 'xxs' })};
  color: ${t`color`};
  border-radius: ${t`border.radius`};
  padding: ${t`padding`};
  max-width: ${t`maxWidth.${'maxWidth'}`};
  overflow-wrap: break-word;
`;
